import styled, { css } from 'styled-components';

export const StyledDownloadContainer = styled.div`
  background-color: ${({ theme, isPremium }) =>
    isPremium ? theme.card : theme.hover};
  border: 1px solid ${({ theme, isPremium }) =>
    isPremium ? theme.border : theme.borderSubtle};
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px;
  margin-right: 5px;
  border-radius: 6px;
  cursor: pointer;
  ${({ isPremium, theme }) => {
    if (!isPremium) {
      return css`
        svg {
          fill: ${theme.textFaint};
          path {
            fill: ${theme.textFaint};
          }
        }
      `;
    }
    return css`
      svg,
      svg path {
        fill: ${theme.text};
      }
    `;
  }}
`;
